import React from 'react';
import { usePageStateLoader, fetchPageState } from '../utilities/hooks/useGlobalPageState';

import VerifyEmailSentPage from './VerifyEmailSentPage';
import ReverifyEmailSentPage from './ReverifyEmailSentPage';
import { VerificationType } from '../types';
import { useAppSelector } from '../stores/redux.store';
import { AidFrontendFeatureGate } from '../providers/FeatureGates';
import { checkFeatureGateOnceInitialized } from '../utilities/feature-flags/feature-gate';

export async function verifyEmailSentLoader({ request }: { request: Request }) {
  if (!(await checkFeatureGateOnceInitialized(AidFrontendFeatureGate.USE_STATE_DATA_LOADERS))) {
    return null;
  }

  return await fetchPageState('/rest/verify-email/sent/state', request, {
    capabilities: ['capability-group--login', 'capability-name--mfa'],
  });
}

export const VerifyOrReverifyEmailSentPage = () => {
  usePageStateLoader();

  const verificationType = useAppSelector(state => state.verifyEmailSent.verificationType);
  return verificationType === VerificationType.Verify ? (
    <VerifyEmailSentPage />
  ) : (
    <ReverifyEmailSentPage />
  );
};

export default VerifyOrReverifyEmailSentPage;
